import { gql } from "@apollo/client";

const GET_MY_CREDITS = gql`
  query MyCredits {
    myCredits {
      totalAmount
      credits {
        id
        expiredAt
        originalAmount
        remainingAmount
        creditType
        billingReason
        stripePriceId
        price
        currency
        trackNeeded
      }
    }
    me {
      id
      activeSubscription {
        id
        stripePriceId
        status
        renew
        endDate
        currency
      }
      paymentMethods {
        id
        brand
        last4
        default
      }
      subscriptions {
        id
        stripePriceId
        status
        renew
        endDate
        currency
      }
      purchaseTrackingStatus
      paymentType
    }
  }
`;

export default GET_MY_CREDITS;
